import React, { PropTypes } from 'react';

const AuditSearchVirtualEntry = ({
  virtualEntryId,
  virtualEventName,
  captainName,
  bowlerName,
  tournamentName,
  onNavigationClick
}) => {
  return (
    <div className="list-group-item-labeled">
      <a className="list-group-item-labeled-child has-link"
        style={{ width: 200 }}
        onClick={() => onNavigationClick(`admin/audit/virtualEntry/${virtualEntryId}`)}>
        <span>{'Virtual Event'}</span>
        <span>{virtualEventName}</span>
      </a>
      <div className="list-group-item-labeled-child"
        style={{ width: 120 }}>
        <span>{'Captain'}</span>
        <span>{captainName}</span>
      </div>
      <div className="list-group-item-labeled-child"
        style={{ width: 120 }}>
        <span>{'Bowler'}</span>
        <span>{bowlerName}</span>
      </div>
      <div className="list-group-item-labeled-child"
        style={{ width: 230 }}>
        <span>{'Tournament'}</span>
        <span>{tournamentName}</span>
      </div>
    </div>
  );
};

AuditSearchVirtualEntry.propTypes = {
  addressBase: PropTypes.string,
  virtualEntryId: PropTypes.string,
  virtualEventName: PropTypes.string,
  captainName: PropTypes.string,
  bowlerName: PropTypes.string,
  tournamentName: PropTypes.string,
  onNavigationClick: PropTypes.func
};

AuditSearchVirtualEntry.defaultProps = {
};

export default AuditSearchVirtualEntry;



// WEBPACK FOOTER //
// ./src/features/admin/audit/virtualEntryAudit/AuditSearchVirtualEntry.jsx